import React from "react";
import {useNavigate} from 'react-router-dom';
import ModalShell from "./ModalShell";

interface ModalProps {
    isOpen: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    content: string,
}

const AlertModal: React.FC<ModalProps> = ({isOpen, setOpen, content}) => {
    const navigate = useNavigate();

    /* Alert user and return to settings. */
    const handleClose = () => {
        setOpen(false);
        navigate(-1);
    };

  return (
    <ModalShell
      open={isOpen}
      onClose={handleClose}
      size="sm"
      title="Notice"
      actions={<button className="btn btn-primary" onClick={handleClose}>OK</button>}
    >
      <p>{content}</p>
    </ModalShell>
  );
};

export default AlertModal;
